const DOWNLOAD_POLL_REPORT_PAGE_PATH = 'download-poll-report';

export { DOWNLOAD_POLL_REPORT_PAGE_PATH };